/* eslint no-unused-vars: "off" */
import React from 'react';
import { formatCurrency } from '../../../services/UtilitiesService';
import {
  OfferDetailsWrapper,
  OfferInfoWrapper,
  OfferTitle,
  OfferAmount,
} from './OfferDetails.styles';

const OfferDetails = ({ appraisalDetails }: any) => {
  const { make, carvanaOffer, expired } = appraisalDetails;
  return (
    <OfferDetailsWrapper>
      <OfferInfoWrapper>
        <OfferTitle data-testid="stc-offer-title">
          {expired
            ? `Prior offer for your ${make}`
            : `Carvana's offer for your ${make}`}
        </OfferTitle>
        <OfferAmount data-testid="stc-offer-amount">
          {formatCurrency(carvanaOffer, 0)}
        </OfferAmount>
      </OfferInfoWrapper>
    </OfferDetailsWrapper>
  );
};

export default OfferDetails;
